import FormElementMixin from "./FormElementMixin";

const FormElementWithPlaceholdersMixin = {
    data() {
        return {
            placeholderListVisibile: false,
            valueWidthPlaceholders: '',
            range: null,
            htmlOpenDelimiter: '<div class="ak-chip ak-chip--small ak-chip--info ak-form__placeholder" data-placeholder="true" contenteditable="false">',
            htmlCloseDelimiter: '<a href="#" class="ak-icon ak-tag__clear" contenteditable="false" data-remove-placeholder="true">clear</a></div>'
        };
    },
    mixins: [FormElementMixin],
    props: {
        openDelimiter: {
            type: String,
            default: '%{'
        },
        closeDelimiter: {
            type: String,
            default: '}'
        },
        triggerDelimiter: {
            type: String,
            default: '%'
        },
        placeholders: {
            type: Object|Array,
        }
    },
    watch: {
        '$localeHandler.activeLocale': function() {
            this.setValueWidthPlaceholders();
        }
    },
    computed: {
        /**
         * Get the active placeholders in a format we can use
         * @return {*}
         */
        activePlaceholders() {
            if (! this.placeholders || ! this.placeholders.values || ! this.placeholders.displayNames) {
                return [];
            }

            return this.getFormattedPlaceholders([], this.placeholders.values, this.placeholders.displayNames);
        },
    },
    methods: {
        blur() {
            this.setRange();
            this.isFocused = false;
            this.$emit('blur');
        },
        focus() {
            this.isFocused = true;
            this.showPlaceholderList(true);
            this.$emit('focus');
        },
        /**
         * Set currentValue
         * @param value
         */
        setCurrentValue() {
            if ( ! this.$refs.input) {
                return;
            }

            let htmlValue = this.$refs.input.innerHTML;

            this.activePlaceholders.forEach(placeholder => {
                // now we revert the labelWidthDelimiters to the valueWidthDelimiters for the value
                htmlValue = htmlValue.replaceAll(placeholder.labelWidthDelimiters, placeholder.valueWidthDelimiters);
            });

            // strip out all nbsp; tags
            htmlValue = htmlValue.replace(/&nbsp;/g, ' ');
            // strip out all leftover html tags (sometimes broken html is leftover when we select and remove placeholders
            htmlValue = htmlValue.replace(/<[^>]*>?/gm, '');

            this.currentValue = this.decodeHtml(htmlValue);
        },
        decodeHtml(html) {
            const txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        /**
         * Show placeholder list
         * @param isOpen
         */
        showPlaceholderList() {
            this.placeholderListVisibile = true;
        },
        /**
         * Show placeholder list
         * @param isOpen
         */
        hidePlaceholderList() {
            this.placeholderListVisibile = false;
        },
        /**
         * Get the placeholders in one object
         *
         * @param out
         * @param placeholders
         * @param displayNames
         * @param activeKey
         * @return {*}
         */
        getFormattedPlaceholders(out, placeholders, displayNames, activeKey = null) {

            for(const propperty in placeholders) {
                let currentActiveKey = activeKey ? activeKey : '';
                const value = placeholders[propperty];
                const displayName =  displayNames ? displayNames[propperty] : null;
                currentActiveKey += currentActiveKey ? `.${propperty}` : propperty;

                if (typeof value !== 'object' || value === null) {
                    const label = displayName ? displayName :currentActiveKey;

                    out.push({
                        value: currentActiveKey,
                        label: label,
                        labelWidthDelimiters: this.htmlOpenDelimiter + label + this.htmlCloseDelimiter,
                        valueWidthDelimiters: this.openDelimiter + currentActiveKey + this.closeDelimiter
                    });
                    continue;
                }

                this.getFormattedPlaceholders(out, value, displayName, currentActiveKey);
            }

            return out;
        },
        /**
         * Insert placeholder
         * @param placeholder
         */
        insertPlaceholder(placeholder) {
            let newValue = this.currentValue;
            // Make sure the current value already has an empty string if it is still null
            if (! this.currentValue) {
                newValue = '';
            }

            // create the html for the placeholder
            const temp = document.createElement('div');
            temp.innerHTML = placeholder.labelWidthDelimiters;
            const placeholderNode = temp.childNodes[0];

            // Check if we have a range (selection)
            if (this.range) {
                // if so we will use this to set the new html
                this.range.deleteContents();
                this.range.insertNode(placeholderNode);
            } else {
                // if no range (selection) we will just append it
                this.$refs.input.appendChild(placeholderNode);
            }

            this.$refs.input.focus();
            const nextText = placeholderNode.nextSibling;
            // set the new selection range after the new element
            this.range = document.createRange();
            if (nextText && nextText.nodeType === Node.TEXT_NODE) {
                this.range.setStart(placeholderNode.nextSibling, 0);
            } else {
                this.range.setStartAfter(placeholderNode);
            }
            this.range.collapse();

            // Get window selection
            const selection = window.getSelection();

            // Add range to window selection
            selection.removeAllRanges();
            selection.addRange(this.range);

            this.$nextTick(this.setCurrentValue);
        },
        /**
         * Convert the current value width placeholders to an html string where we replace the placeholders width div element width custom styling
         */
        setValueWidthPlaceholders() {
            let value = this.currentValue;

            if (value) {

                this.activePlaceholders.forEach(placeholder => {
                    // now we revert the labelWidthDelimiters to the valueWidthDelimiters for the value
                    value = value.replaceAll(placeholder.valueWidthDelimiters, placeholder.labelWidthDelimiters);
                });
            }

            this.valueWidthPlaceholders = value;
            this.$nextTick(this.setCurrentValue);
        },
        /**
         * Check if the remove placeholder button is clicked
         * @param e
         */
        checkRemovePlaceholder(e) {
            if ( ! e.target.dataset || ! e.target.dataset.removePlaceholder) {
                return;
            }
            e.preventDefault();

            const $placeholder = e.target.closest('[data-placeholder]');
            $placeholder.remove();

            this.$nextTick(this.setCurrentValue);
        },
        /**
         * Set the current selection range
         * So we can use it on insert of the placeholder
         */
        setRange() {
            this.range = window.getSelection().getRangeAt(0).cloneRange();
        }
    },
    mounted() {
        this.$el.addEventListener('click', this.checkRemovePlaceholder);
        this.setValueWidthPlaceholders();
    },
    beforeDestroy() {
        this.$el.removeEventListener('click', this.checkRemovePlaceholder);
    }
}

export default FormElementWithPlaceholdersMixin;